import { IRouteConfig } from "services/typings";
import { lazy } from "utils/route";

const routes: IRouteConfig[] = [
  {
    path: "/marketing-assets/reservation-campaign/:campaignId/aff",
    exact: true,
    component: lazy(() => import("./BrandSolutionPortal")),
  },
  {
    path: "/marketing-assets/campaign-operation/campaign/affiliate/:id/:tab",
    exact: true,
    component: lazy(() => import("./CampaignDetail")),
  },
];

export default routes;
